import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { useFormik } from 'formik';
import { PaymentsEftRecordStatus } from '../../../models/DeprecatedEnums';
import { PaymentValidations } from '../../../validations/PaymentValidations';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import { GeneralHelper } from '../../../helpers/GeneralHelper';

interface ChangeEftRecordStatusComponentProps {
  selectedRecord: any;
  updateRecordStatus: any;
  toggleDialog: (show: boolean) => void;
  show: boolean;
}

const ChangeEftRecordStatusComponent = (props: ChangeEftRecordStatusComponentProps) => {
  const { selectedRecord, updateRecordStatus, show, toggleDialog } = props;

  const defaultForm: any = {
    status: PaymentsEftRecordStatus.PENDING
  };

  const formik = useFormik({
    initialValues: defaultForm,
    validationSchema: PaymentValidations.changeEftRecordStatusValidation(),
    onSubmit: async values => {
      if (!selectedRecord) return;
      updateRecordStatus(values.status);
    }
  });

  return (
    <Dialog open={show} onClose={() => toggleDialog(false)} maxWidth={'sm'} fullWidth={true}>
      <DialogTitle>Change Status</DialogTitle>
      <DialogContent>
        <form autoComplete={'off'} autoCorrect={'off'} onSubmit={formik.handleSubmit} className={'form'}>
          {formik.status && (
            <div className={'mb-10 alert alert-custom alert-light-danger alert-dismissable'}>
              <div className={'alert-text font-weight-bold'}>{formik.status}</div>
            </div>
          )}

          <p>
            The only statuses available are:{' '}
            {`${PaymentsEftRecordStatus.PENDING}, ${PaymentsEftRecordStatus.IGNORE}, ${PaymentsEftRecordStatus.DUPLICATE}`}. <br />
            All other statuses are processed and handled by Proxima.
          </p>

          <div className={'form-group mt-4'}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">New Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="New Status"
                error={GeneralHelper.formFieldHasError(formik, 'status')}
                {...formik.getFieldProps('status')}
              >
                <MenuItem value={PaymentsEftRecordStatus.PENDING}>{PaymentsEftRecordStatus.PENDING}</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className={'row align-items-center'}>
            <div className={'col-auto'}>
              <Button variant={'text'} onClick={() => toggleDialog(false)}>
                Cancel
              </Button>
            </div>
            <div className={'col'}>
              <Button variant={'contained'} disableElevation={true} type={'submit'}>
                Change status
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeEftRecordStatusComponent;
